module.exports = __webpack_public_path__ + "e58db0fb2ab988f3c7d43f9b3ab15805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-tasukarimasu.png
// module id = 2042
// module chunks = 4